import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Trophy, Medal, Award } from "lucide-react";

const RANK_ICONS = [Trophy, Medal, Award];
const RANK_COLORS = ["hsl(45 85% 68%)", "hsl(210 15% 78%)", "hsl(25 70% 60%)"];

export default function ReferralLeaderboard() {
    const [board, setBoard] = useState(null);

    useEffect(() => {
        api.get("/leaderboard/referrals").then(({ data }) => setBoard(data)).catch(() => setBoard([]));
    }, []);

    if (!board) return null;
    if (board.length === 0) return null;

    return (
        <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24" data-testid="referral-leaderboard">
            <div className="mb-8 flex items-baseline justify-between flex-wrap gap-2">
                <div>
                    <div className="text-[10px] uppercase tracking-[0.35em] text-[hsl(45_85%_68%)] mb-2">Hall of Residuals</div>
                    <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tighter">Top silent partners<br />collecting referral residuals.</h2>
                </div>
                <p className="text-sm text-muted-foreground max-w-sm">
                    Anonymised. Updated live. Every name on this board earns a recurring cut of every agency they bring aboard.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-3">
                {board.slice(0, 5).map((row, idx) => {
                    const Icon = RANK_ICONS[idx] || Trophy;
                    const color = RANK_COLORS[idx] || "hsl(45 60% 55%)";
                    return (
                        <div key={idx} className="glass rounded-2xl p-5 relative overflow-hidden" data-testid={`lb-row-${idx}`}>
                            {idx < 3 && (
                                <div className="absolute -top-8 -right-8 w-24 h-24 rounded-full blur-2xl opacity-30" style={{ background: color }} />
                            )}
                            <div className="relative">
                                <div className="flex items-center gap-2">
                                    <Icon size={18} style={{ color }} strokeWidth={1.5} />
                                    <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">#{row.rank}</span>
                                </div>
                                <div className="mt-3 font-heading text-4xl tracking-tighter font-mono" style={{ color }} data-testid={`lb-initials-${idx}`}>
                                    {row.initials}
                                </div>
                                <div className="mt-4 pt-3 border-t border-[hsl(40_40%_30%/0.15)] space-y-1">
                                    <div className="flex items-baseline justify-between text-xs">
                                        <span className="text-muted-foreground uppercase tracking-wider">Referrals</span>
                                        <span className="font-mono">{row.referrals}</span>
                                    </div>
                                    <div className="flex items-baseline justify-between text-xs">
                                        <span className="text-muted-foreground uppercase tracking-wider">Pool</span>
                                        <span className="font-mono text-[hsl(45_85%_68%)]">${Number(row.earnings).toLocaleString()}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
